import React, {Component} from 'react';
import ReactDOM from 'react-dom'
import ReactModal from 'react-modal';
import axios from 'axios'

const ModalStyles = {
  overlay: {
	  backgroundColor: 'rgba(0, 0, 0, 0.75)'
  },
  	content : {
  	padding				  			: '0',
		width				  				: '940px',
		maxWidth			  			: '940px',
		height				  			: 'auto',
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    marginRight           : '-50%',
    transform             : 'translate(-50%, -50%)'
  }
};

ReactModal.setAppElement('body');

class Bookmark extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			bookmarked: this.props.bookmarked,
			type: 1,
			showModal: false
		};
	}

	handleCloseModal = () => {
		this.setState({ showModal: false });
	}

	handleClick = (event) => {
		event.preventDefault();

		this.setState({ showModal: true })
		const url = '/bookmark.json?item=' + this.props.id + '&type=' + this.state.type;
		axios.get( url ).then(response => {
			this.setState({
				bookmarked: response.data.status
			});
		}).catch(err => {
			console.log(err);
		});

	}

	render() {
		const heartClass = this.state.bookmarked ? 'icon icon-heart-full' : 'icon icon-heart'
		return (
			<div>
				<a><span className={heartClass} onClick={this.handleClick}></span></a>
				<ReactModal isOpen={this.state.showModal} style={ModalStyles}>
          <div className="bookmark__modal--container">
						{this.state.bookmarked == true ?
						<div className="saved-message">
							<h3>Activity Saved</h3>
							<p>you have sucessfully saved this activity to your account</p>
						</div>
						:
						<div className="removed-message">
							<h3>Activity Removed</h3>
							<p>you have sucessfully removed this activity from your account</p>
						</div>
						}
            <button className="bookmark__modal--close-button" onClick={this.handleCloseModal}><span className="icon icon-cross"></span></button>
          </div>
        </ReactModal>
			</div>
		)
	}
}

document.addEventListener('DOMContentLoaded', () => {
	var bookmark_list = document.querySelectorAll('.cpt-bookmark');
	var bookmarks = [...bookmark_list]; // converts NodeList to Array

	bookmarks.forEach(bookmark => {

	if( bookmark !== null ) {
		let bookmarked = false;
		if( bookmark.getAttribute('bookmarked') !== null && bookmark.getAttribute('bookmarked') == 'true' ) {
			let bookmarked = true;
		}

		const id = bookmark.getAttribute('id');
		ReactDOM.render( <Bookmark id={id} bookmarked={bookmarked} />, bookmark )
	}
	});
})
